import { render, staticRenderFns } from "./HeroesPage.vue?vue&type=template&id=473c45e5&"
import script from "./HeroesPage.vue?vue&type=script&lang=js&"
export * from "./HeroesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports